import { Skeleton } from "@mui/material";

const ITEM_SKELETON_HEIGHT = 20;

export const FilterListItemSkeleton = () => (
  <>
    <div>
      <Skeleton sx={{ width: 16, height: ITEM_SKELETON_HEIGHT }} />
    </div>
    <Skeleton
      sx={{ ml: 1.5, mr: 1.5, width: 100, height: ITEM_SKELETON_HEIGHT }}
    />
    <div>
      <Skeleton sx={{ width: 30, height: ITEM_SKELETON_HEIGHT }} />
    </div>
  </>
);
